import Vue from "vue";
import "@babel/polyfill";
import App from "./App.vue";
import router from "./router";
import store from "@/store";
import "./filters";
import "element-ui/lib/theme-chalk/index.css";
import plugins from "@/plugins";
import "./assets/css/base.scss";
import "./icons"; // 导入SVG图标
// 引入阿里图标库
import "./assets/iconfont/iconfont.css";
import "./assets/iconfont/base/baseiconfont.css";
import "./assets/iconfont/iconfont.js";
import "@/utils/rem";
import myComponents from "@/components";
Vue.use(myComponents);
import directives from "@/directives"; // 自定义指令
Vue.use(directives);
import request from "@/api";
Vue.prototype.$request = request;
import { injectBuildTimeStampToWindow } from "../scripts/syncBuildTimeStamp";
import VueCoreVideoPlayer from "vue-core-video-player";
injectBuildTimeStampToWindow();
Vue.config.productionTip = false;
Vue.use(plugins, {});
Vue.use(VueCoreVideoPlayer, {
  lang: "zh-CN"
});
const _vue = new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount("#app");

export default _vue;
